import { inject } from '@angular/core';

import { AnalyticsService } from '@pt/services';

export function registerAnalyticsFactory() {
  const analyticsService = inject(AnalyticsService, { optional: true });
  return () => analyticsService?.init();
}
